import moment from "moment";
import defaultReducer from "./defaultReducer";

export const graphInitialState = {
  lines: [],
  data: [],
};

export const gridInitialState = {
  data: [],
  headerDef: [],
  rowDef: [],
  pageCount: 1,
  pageNumber: 1,
};

export const analysisInitialState = {
  startDate: moment().subtract(14, "days").utc().set({ m: 0, s: 0, h: 0 }),
  endDate: moment().set({ m: 0, s: 0, h: 23 }),
  selectedStartTime: 8,
  selectedEndTime: 18,
  loading: false,
  detailsLoading: false,
  graphType: 1,
  selectedRows: [],
  selectedTimeGroupBy: null,
  selectedTotalBy: null,
  selectedMeasure: null, // for data types single select
  selectedMeasures: [], // for data types multi select
  selectedDayOfWeek: [],
  selectedDataGroup: null,
  selectedCategory: [],
  timeGroupBy: [],
  filteredTimeGroupBy: [],
  dataGroups: [],
  categories: [],
  daysOfWeek: [],
  dataSource: [],
  measures: [],
  weeks: [],
  defaultMeasures: [],
  totalBy: [],
  grid: gridInitialState,
  details: gridInitialState,
  graph: graphInitialState,
  hideGraph: true,
  hideFilters: false,
  activeTab: 0,
};

export const analysisReducer = defaultReducer(
  "ANALYSIS_VIEW",
  analysisInitialState,
);
